import axios from 'axios'
import { baseUrl } from './config'

export function getTrustPointsInUser (params) {
  return axios.get(`${baseUrl}/trust-points`, {
    params
  })
}

export function getTrustPoints (params) {
  return axios.get(`${baseUrl}/trust-points/by-user`, {
    params
  })
}

export function checkTrustPoints (id) {
  return axios.post(`${baseUrl}/trust-points/${id}`)
}

export function updateTrustPoints (id) {
  return axios.put(`${baseUrl}/trust-points/${id}`)
}
